module.exports = __webpack_public_path__ + "img/history_icon.874347ff.svg";